module.exports = __webpack_public_path__ + "static/media/logo.769a4784.svg";